module.exports = __webpack_public_path__ + "img/2017-12-25.b8ebebe1.jpg";